import { Component, OnDestroy, OnInit } from '@angular/core';
import { lastDayOfMonth } from 'date-fns';
import { DateTimeService } from 'src/app/services/general/date-time.service';
import { NewsType } from 'src/app/types/news';

@Component({
  selector: 'app-news-card-tnc',
  templateUrl: './news-card-tnc.component.html',
  styleUrls: ['./news-card-tnc.component.scss'],
})
export class NewsCardTncComponent implements OnInit, OnDestroy {

  type: NewsType;

  month: string;
  year: number;
  lastDate: number;

  constructor(
    private dateTimeService: DateTimeService,
  ) { }

  ngOnInit() {}

  ngOnDestroy() {}

  ionViewWillEnter() {
    if (this.type === 'account_voucher') {
      this.setupDate();
    }
  }

  setupDate() {
    const date = new Date();
    this.year = date.getFullYear();
    this.lastDate = lastDayOfMonth(date).getDate();
    this.month = this.dateTimeService.format(date, 'LLLL');
  }

}
